/* Functions for the top-info-bar */
const showMoreButton = document.querySelector( '.info-bar-content--show-more' );
const showLessButton = document.querySelector( '.info-bar-content--show-less' );
const additionalInfo = document.querySelector( '.info-bar-content--additional-text' );
const infoBarElement = document.querySelector( '.info-bar' );

if ( showMoreButton ) {
	showMoreButton.addEventListener( 'click', function( e ) {
		e.preventDefault();
		toggleExpandInformationBar();
	} );
}

if ( showLessButton ) {
	showLessButton.addEventListener( 'click', function( e ) {
		e.preventDefault();
		toggleExpandInformationBar();
	} );
}

/**
 * Toggles the 'expanded' class on the .info-bar
 */
function toggleExpandInformationBar() {
	if ( infoBarElement.classList.contains( 'expanded' ) ) {
		additionalInfo.setAttribute( 'aria-hidden', true );
		additionalInfo.setAttribute( 'tabindex', -1 );
	} else {
		additionalInfo.removeAttribute( 'aria-hidden' );
		additionalInfo.removeAttribute( 'tabindex' );
	}

	infoBarElement.classList.toggle( 'expanded' );
}
